<template>
  <div class="home">
    <main>
      <Header />
      <div class="Media">
        <div class="wrapper">
          <div class="Media__inner">
            <a
              :href="slide.href"
              class="Media__media"
              v-for="slide in slidesMedia"
              :key="slide.href"
              target="_blank"
            >
              <div class="Media__image">
                <img
                  :src="require(`@/assets/images/${slide.logo}`)"
                  :alt="slide.href"
                />
              </div>
            </a>
          </div>
        </div>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import { AuxiliaryHeader as Header } from "@/components/app/Headers";
import { mapGetters } from "vuex";

export default {
  name: "Media",
  computed: mapGetters(["slidesMedia"]),
  components: {
    Header
  }
};
</script>
